var advanceCarousel, makeNavActive, showSlide, startCarousel, stopCarousel;

$(function() {
  var preventClick;
  preventClick = false;
  if ($('body').hasClass('coupons-home')) {
    $('.carousel-container > .row').first().show();
    $('#featured-coupons-nav a').first().addClass('active');
    if (!$('html').hasClass('lt-ie9')) {
      window.Coupons.carouselInt = self.setInterval(startCarousel, 5500);
      Groupon.Utils.lazyLoadImages({
        skip_invisible: false
      }, '.carousel-container .lazy-load');
    }
  }
  $('.featured-coupons-left, .featured-coupons-right').on('click', function() {
    stopCarousel();
    advanceCarousel($(this));
  });
  $('#popular-stores-left, #popular-stores-right').on('click', function() {
    advanceCarousel(this);
  });
  return $('#featured-coupons-nav a').on('click', function() {
    var carousel, ind;
    if (preventClick !== true) {
      preventClick = true;
      ind = $(this).index();
      carousel = $('.main');
      showSlide(ind, carousel);
      makeNavActive(ind);
      stopCarousel();
      setTimeout((function() {
        return preventClick = false;
      }), 500);
    }
  });
});

startCarousel = function() {
  return advanceCarousel($('.main .carousel-container .feature:visible').find('.featured-coupons-right'));
};

stopCarousel = function() {
  return window.Coupons.carouselInt = window.clearInterval(window.Coupons.carouselInt);
};

advanceCarousel = function(clickedElement) {
  var carousel, currentSlide, direction, nextSlide, numberOfSlides;
  carousel = $(clickedElement).parent().parent();
  direction = $(clickedElement).attr('data-carousel-direction');
  currentSlide = $(carousel).find('.feature').not(':hidden').index();
  numberOfSlides = $(carousel).find('.feature').length;
  if (direction === 'left') {
    if (currentSlide === 0) {
      nextSlide = numberOfSlides - 1;
    } else {
      nextSlide = currentSlide - 1;
    }
  }
  if (direction === 'right') {
    if (currentSlide === (numberOfSlides - 1)) {
      nextSlide = 0;
    } else {
      nextSlide = currentSlide + 1;
    }
  }
  showSlide(nextSlide, carousel);
  if ($(carousel).data('carousel') === 'featured') {
    makeNavActive(nextSlide);
  }
};

showSlide = function(ind, carousel) {
  $(carousel).find('.feature').not(':hidden').fadeOut('fast', function() {
    return $(carousel).find('.feature:eq(' + ind + ')').fadeIn('fast');
  });
};

makeNavActive = function(ind) {
  var carousel;
  carousel = $('#featured-coupons');
  $('#featured-coupons-nav a').removeClass('active');
  $('#featured-coupons-nav a:eq(' + ind + ')').addClass('active');
};

